export default "__VITE_ASSET__BZkPtsen__"